import { api } from 'api';
import { getNotifications, getPermission, getShopInfo, getShopPlanInfo } from 'api/service';
import {
  FETCH_SHOPINFO,
  SET_ACCESSIBILITY_AND_CURRENT_PLAN,
  SET_CURRENT_PLAN,
  SET_NOTIFICATIONS,
  UPDATE_CAN_ADD_ACTION,
  UPDATE_DASHBOARD_REPORT,
  UPDATE_DASHBOARD_REPORT_FAILED,
  UPDATE_DASHBOARD_REPORT_LOADING,
  UPDATE_SHOP_INFO,
} from '../constants';

export const getShopInfoAction =
  (dispatch) =>
  async (host = '', isLoginPage = false, afterFetch) => {
    if (isLoginPage) {
      dispatch({
        type: FETCH_SHOPINFO,
        payload: {},
      });
      return;
    }
    // /shop-info and /permission are independent requests — permission does not
    // read anything out of the shop-info response. Nesting the second inside the
    // first's callback made them two serial round-trips on the critical boot
    // path, and App.js blocks first paint on BOTH, so their latencies used to
    // add straight into LCP. Fire them together instead.
    getShopInfo((success, data) => {
      if (success) {
        dispatch({
          type: FETCH_SHOPINFO,
          payload: { host, ...data },
        });
      } else {
        dispatch({ type: FETCH_SHOPINFO, payload: { host } });
      }
    });
    getPermissionAction(dispatch)(afterFetch);
    // NOTE: /api/common/getNotifications isn't implemented on the backend (returns 404),
    // and getShopInfoAction runs on every shop-info load — so this fired a useless 404
    // request constantly. Disabled until the notifications endpoint exists. The
    // getNotificationsAction below is still used by NotificationBanner's onDismiss.
    // getNotificationsAction(dispatch)();
  };
export const getNotificationsAction = (dispatch) => async (filter) => {
  getNotifications(filter, (success, data) => {
    if (success) {
      dispatch({
        type: SET_NOTIFICATIONS,
        payload: data.data,
      });
    }
  });
};
export const getDasboardReport = (dispatch) => async (disablePageLoading) => {
  api.getCampaignReportByStatus().then((res) => {
    // console.log('[getCampaignReportByStatus response]', res);
    // console.log('[res.data]', res?.data);
    // console.log('[res.data.data]', res?.data?.data);
    // console.log('[keys]', Object.keys(res?.data?.data || {}));

    if (res?.data?.success) {
      dispatch({
        type: UPDATE_DASHBOARD_REPORT,
        payload: res?.data?.data,
      });
    } else {
      dispatch({ type: UPDATE_DASHBOARD_REPORT_FAILED });
    }
    disablePageLoading && disablePageLoading();
  });
};
export const getCurrentPlanInfo = (dispatch) => async (afterFetch) => {
  getShopPlanInfo((success, data) => {
    if (success) {
      dispatch({
        type: SET_CURRENT_PLAN,
        payload: data?.data,
      });
      afterFetch && afterFetch();
    }
  });
};
export const getPermissionAction = (dispatch) => async (afterFetch) => {
  getPermission((success, data) => {
    if (success) {
      dispatch({
        type: SET_ACCESSIBILITY_AND_CURRENT_PLAN,
        payload: {
          accessibility: {
            canAddCampaign: data?.data.canAddCampaign,
            trialEligible: data?.data.trialEligible,
            permissions: data?.data.permissions,
            countdownUsage: data?.data.countdownUsage,
          },
          currentPlan: data?.data.currentPlan,

          currentPlanFeatures: data?.data.currentPlanFeatures,
          currentPlanFeatureKeys: data?.data.currentPlanFeatureKeys,
          featureMinPlan: data?.data.featureMinPlan,
        },
      });
    }
    // Always run the continuation, even when the permission refresh fails. Callers pass
    // it to finalize their flow (reset a Save spinner, navigate, run afterSave/afterDelete).
    // Gating it on `success` left the Save button spinning forever whenever this secondary
    // request errored — the campaign had already saved, but the UI never recovered.
    afterFetch && afterFetch();
  });
};

export const updateShopInfo = (dispatch) => (data) => {
  dispatch({ type: UPDATE_SHOP_INFO, payload: { ...data } });
};
export const updateCanAddAction = (dispatch) => (data) => {
  dispatch({ type: UPDATE_CAN_ADD_ACTION, payload: data });
};
export const updateDashboardReportLoading = (dispatch) => (loading) => {
  dispatch({ type: UPDATE_DASHBOARD_REPORT_LOADING, payload: loading });
};
